import axios from "axios";

export default axios.create({
  baseURL: "https://forum-api.sam-si.cn/publisher",
});
